import cookies from 'vue-cookies'
import * as API from '@/api';


export const member = {
  state: {
    isLogin: false,
    userId: '',
    userEmail: '',
    forgotEmail: '',
  },
  getters: {
    getLoginStatus: state => {
      return state.isLogin
    },
    getUserId: state => {
      return state.userId
    },
    getUserEmail: state => {
      return state.userEmail
    },
    getForgotEmail: state => {
      return state.forgotEmail
    },
  },
  mutations: {
    setLoginStatus(state, payload) {
      state.isLogin = payload
    },
    setUserId(state, payload) {
      state.userId = payload
    },
    setUserEmail(state, payload) {
      state.userEmail = payload
    },
    setForgotEmail(state, payload) {
      state.forgotEmail = payload
    },
  },
  actions: {
    async loginRequest({ commit }, user) {
      const res = await API.POST('/login', user)
      cookies.set('templeFrontStageApiToken', res.data.api_token)
      commit('setLoginStatus', true)
      commit('setUserId', res.data.id)
      commit('setUserEmail', res.data.email)
    },
    async FBlogin({ commit }, user) {
      const res = await API.POST('/facebook-login', user)

      cookies.set('templeFrontStageApiToken', res.data.api_token)

      commit('setLoginStatus', true)
      commit('setUserId', res.data.id)
      commit('setUserEmail', res.data.email)
    },
    async signupRequest({ commit }, user) {
      const res = await API.POST('/signup', user)
      cookies.set('templeFrontStageApiToken', res.data.api_token)
      commit('setLoginStatus', true)
      commit('setUserId', res.data.id)
      commit('setUserEmail', res.data.email)
    },
    logout({ commit }) {
      cookies.remove('templeFrontStageApiToken')
      commit('setLoginStatus', false)
      commit('setUserId', '')
      commit('setUserEmail', '')
    },
    async forgotPassword({ commit }, user) {
      const response = await API.POST('reset-password-code', user)

      return response
    },
    async resetPassword({ commit }, user) {
      const response = await API.POST('reset-password', user)

      return response
    }
  }
}